


























































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio, Select, SwitchToggle } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

// models
import { ReasonForPermissionForm } from '@/models/config'
import { PropOptionSelect } from '@/models'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { ReasonForPermissionService } from '@/services/config'

const initItem: ReasonForPermissionForm = {
    description: '',
    abbreviated: '',
    type: '',
    has_subsidy: false,
    apply_sunday_discount: false,
    is_active: true
}

@Component({
    name: 'FormCreateEditReasonForPermission',
    components: {
        Input,
        Radio,
        Select,
        SwitchToggle
    },
    mixins: [validationMixin]
})
export default class FormCreateEditReasonForPermission extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) reason!: ReasonForPermissionForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    form: ReasonForPermissionForm = {
        description: '',
        abbreviated: '',
        type: '',
        has_subsidy: false,
        apply_sunday_discount: false,
        is_active: true
    }

    get options (): PropOptionSelect[] {
        return [
            {
                text: 'Con Goce de Haber',
                value: 'Con Goce de Haber'
            },
            {
                text: 'Sin Goce de Haber',
                value: 'Sin Goce de Haber'
            }
        ]
    }

    created () {
        if (this.idEdit) {
            this.form = this.reason
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                description: { required },
                abbreviated: { required },
                type: { required },
                is_active: { required }
            }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await ReasonForPermissionService.update(this.idEdit, this.form)
                } else {
                    await ReasonForPermissionService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = initItem
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }
}
